import { DeepThoughtsSummaryContent } from "@/components/conversations/activities/deep-thoughts/deep-thoughts-summary-content";
import {
  isDeepThoughtsActivity,
  useActivity,
  useActivityDefinition,
} from "@/lib/api/activities";
import type { DeepThoughtsDefinition } from "@somethings-ui/core/deep-thoughts";
import { Loader2 } from "lucide-react";

interface ViewDeepThoughtsViewProps {
  entityId: string;
}

export function ViewDeepThoughtsView({ entityId }: ViewDeepThoughtsViewProps) {
  const { data: activity, isLoading, isError } = useActivity(entityId);
  const { data: definition } =
    useActivityDefinition<DeepThoughtsDefinition>("deep_thoughts");

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center bg-white">
        <Loader2 className="h-8 w-8 animate-spin text-zinc-400" />
      </div>
    );
  }

  if (isError || !isDeepThoughtsActivity(activity) || !activity.result) {
    return (
      <div className="flex h-full items-center justify-center bg-white p-6">
        <p className="text-sm text-secondary">Unable to load Deep Thoughts.</p>
      </div>
    );
  }

  const result = activity.result;

  return (
    <div className="h-full overflow-y-auto bg-white">
      <DeepThoughtsSummaryContent
        result={result}
        definition={definition}
        completedAt={activity.completedAt}
      />
    </div>
  );
}
